import { ResourceProps } from 'react-admin';
import { DataResourceOptions } from '../../common/types';

export const resourceProps: ResourceProps = {
  name: 'integrations-remote-references',
};

export default {
  name: 'integrations-remote-references',
  singularName: 'integrations-remote-reference',
  payloadKey: 'integrations/remote_references',
  singularPayloadKey: 'integrations/remote_reference',
  localized: false,
} as DataResourceOptions;
